
import { defineComponent, computed, onBeforeMount, ref } from 'vue';
import { useRouter } from 'vue-router';
import { TCell, TEmpty } from '@tencent/web-vbui';
import { spin } from '@tencent/web-vbui/src/components/t-spin/spin';
import { useGlobalState } from '../../store/carOwnerRight';
import { GetRecordList } from '../../core/network/NodeAPI';
import { IRecordListData } from '../../core/interface/IModel';
import { IRightConfig } from '@common/core/interface/IModel';
import { navigator } from '@tencent/vb-app-bridge';
import { to } from '@tencent/vb-web-base-core';
import { i18n } from '@tencent/vb-web-base';
import { baseMixins } from '@common/mixins/baseMixins';
import dayjs from 'dayjs';
interface RecordInfo {
  award_type: number;
  text: string;
  award_name: string;
  create_time: string;
  activity_no: string;
  award_record_no: string;
}
export default defineComponent({
  name: 'RecordList',
  components: {
    TCell,
    TEmpty,
  },
  setup() {
    const router = useRouter();
    const { getLang, getT } = i18n;
    const $t = getT();
    const lang = getLang();
    const state = useGlobalState();
    const isRequested = ref(false);
    const { setTitle, showModalError } = baseMixins();
    setTitle($t('领取记录'));
    const activityNoList = computed<string[]>(() =>
      (state.value.curRights as IRightConfig[]).reduce((prev, cur) => prev.concat(cur.activity), [] as string[]),
    );
    const recordList = ref<IRecordListData['recordList']>([]);
    onBeforeMount(async () => {
      spin.show();
      const [data, err] = await to(GetRecordList(activityNoList.value));
      if (err) {
        showModalError(err.message, err.code);
        spin.hide();
        isRequested.value = true;
        return;
      }
      spin.hide();
      isRequested.value = true;
      recordList.value = data.recordList.map((item) => {
        try {
          // eslint-disable-next-line no-param-reassign
          item.award_name = JSON.parse(item.award_name)[lang];
        } catch (err) {}
        return item;
      });
    });
    const handleClick = (item: RecordInfo) => {
      // 现金类奖品跳转到/recordCashDetail页面
      if (item.award_type === 2 || item.award_type === 3 || item.award_type === 5) {
        try {
          const extraInfo = JSON.parse(item.text);
          const { money } = extraInfo;
          router.push({
            path: '/recordCashDetail',
            query: {
              awardName: item.award_name,
              createTime: item.create_time,
              activityNo: item.activity_no,
              money: money ? Number(money) : '',
            },
          });
          return;
        } catch (err) {
          showModalError(err as string);
        }
      }
      if (item.award_type === 1 || item.award_type === 8) {
        try {
          const extraInfo = JSON.parse(item.text);
          const { couponCode } = extraInfo;
          navigator.push({
            path: '/e/my/coupon.html/couponDetail',
            query: {
              couponCode,
            },
          });
          return;
        } catch (err) {
          showModalError(err as string);
        }
      } else {
        window.top!.location.href = `/h5/act/cdk-award/index.html?id=${item.award_record_no}`;
      }
    };
    return {
      isRequested,
      recordList,
      lang,
      dayjs,
      handleClick,
    };
  },
});
